import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: "Home",
      component: () => import('../views/home/index.vue')
    },
    {
      path: '/login',
      name: "Login",
      component: () => import('../views/home/login.vue'),
      meta: {
        loginRequest: true
      }
    },
    {
      path: '/auth',
      name: "Auth",
      component: () => import('../views/user/auth/index.vue')
    },
    {
      path: '/404',
      name: "Error",
      component: () => import('../views/404.vue')
    },
    {
      path: `/borrow/:id`,
      name: "BorrowIn",
      component: () => import('../views/user/borrow/index.vue')
    },
    {
      path: '/borrow/:id',
      name: "BorrowDute",
      component: () => import('../views/user/borrow/index.vue')
    },
    {
      path: '/borrow/:id',
      name: 'BorrowPastDue',
      component: () => import('../views/user/borrow/index.vue')
    },
    {
      path: '/borrow/:id',
      name: 'BorrowList',
      component: () => import('../views/user/borrow/index.vue')
    },
    {
      path: '/user/center',
      name: 'UserCenter',
      component: () => import('../views/user/center/index.vue')
    },
    {
      path: '/order',
      name: 'UserOrder',
      component: () => import('../views/order/index.vue')
    },
    {
      path: '/query-book',
      name: 'QueryBook',
      component: () => import('../views/queryBook/index.vue')
    },
    {
      path: '/rank',
      name: 'Rank',
      component: () => import('../views/rank/index.vue')
    },
    {
      path: '/pay',
      name: 'Pay',
      component: () => import('../views/pay/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/pay-result',
      name: 'PaySuccess',
      component: () => import('../views/pay/payResult.vue')
    },
    {
      path: '/book/detail',
      name: 'BookDetail',
      component: () => import('../components/bookdetail/index.vue')
    },
    {
      path: '/room',
      name: 'Room',
      component: () => import('../views/room/index.vue')
    },
    {
      path: '/seat',
      name: 'Seat',
      component: () => import('../views/seat/index.vue')
    },
    {
      path: '/preordered/code',
      name: 'preorderedCode',
      component: () => import('../views/preorderedCode/index.vue')
    },
    {
      path: '/code',
      name: 'Code',
      component: () => import('../views/code/index.vue')
    },
    {
      path: '/user/detail',
      name: 'UserDetail',
      component: () => import('../views/user/detail/index.vue')
    },
    {
      path: '/record',
      name: 'Record',
      component: () => import('../views/record/index.vue')
    },
    {
      path: '/e-resources',
      name: 'Resources',
      component: () => import('../views/eResources/index.vue')
    },
    {
      path: '/before/borrow',
      name: 'BeforeBorrow',
      component: () => import('../views/beforeBorrow/index.vue')
    },
    {
      path: '/preordered',
      name: 'Preordered',
      component: () => import('../views/preordered/index.vue')
    },
    // 检索出的书籍
    {
      path: '/books',
      name: 'Books',
      component: () => import('../views/bookSearch/index.vue')
    },
    // 书籍详情
    {
      path: '/books/details',
      name: 'BooksDetails',
      component: () => import('@/views/bookSearch/details.vue')
    },
    {
      path: '/books/result',
      name: 'BooksResult',
      component:() => import('@/views/bookSearch/result.vue') 
    },
    {
      path: '/news/:type',
      name: 'news',
      component: () => import('@/views/news/index.vue')
    },
    {
      path: '/news/details/:id',
      name: 'NewsDetails',
      component: () => import('@/views/news/details.vue')
    }
  ]
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js